import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const Coupon = Styled(
    createSvgIcon(
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">

            <path d="M5.60817 16.4165C6.2915 15.6832 7.33317 15.7415 7.93317 16.5415L8.77484 17.6665C9.44984 18.5582 10.5415 18.5582 11.2165 17.6665L12.0582 16.5415C12.6582 15.7415 13.6998 15.6832 14.3832 16.4165C15.8665 17.9998 17.0748 17.4748 17.0748 15.2582V5.8665C17.0832 2.50817 16.2998 1.6665 13.1498 1.6665H6.84984C3.69984 1.6665 2.9165 2.50817 2.9165 5.8665V15.2498C2.9165 17.4748 4.13317 17.9915 5.60817 16.4165Z" stroke="#246DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.5 10.8335L12.5 5.8335" stroke="#246DFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.4956 10.8332H12.5031" stroke="#246DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.49559 6.25016H7.50307" stroke="#246DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        "Coupon",
    ),
);

export default Coupon;

